import actionable from "../public/images/advertise/actionable.svg";
import affordable from "../public/images/advertise/affordable.svg";
import relevantIcon from "../public/images/advertise/relevant.svg";
import targetedIcon from "../public/images/advertise/targeted.svg";

export const benefitItemsMap = [
  {
    title: "Targeted",
    description:
      "Say goodbye to wasting money on irrelevant traffic. Target your ideal demographic with precision by reaching the right audience in the desired location.",
    icon: targetedIcon,
    iconColor: "#80F730",
  },
  {
    title: "Relevant",
    description:
      "Say goodbye to tire-kickers and hello to meaningful impressions. Only individuals who have expressed a need for your products or services will see your ad.",
    icon: relevantIcon,
    iconColor: "#00DEA3",
  },
  {
    title: "Affordable",
    description:
      "No more paying for fruitless clicks. EasyDuct ensures that you only pay for clicks from users who take the initiative. This optimizes your advertising budget.",
    icon: affordable,
    iconColor: "#00CAD0",
  },
  {
    title: "Actionable",
    description:
      "No more false leads. EasyDuct Only provides you with qualified prospects who have the potential to become customers. So you can focus your effort on valuable leads.",
    icon: actionable,
    iconColor: "#00B7FB",
  },
];
